<template>
  <!-- Desktop Web: TopBar + SideMenu -->
  <template v-if="layoutContext === LAYOUT_CONTEXT.DESKTOP_WEB">
    <TopBarDesktop />
    <SideMenuDesktop />
    <LogsActionsDrawer
      v-model:is-open="isOpen"
      :service-name="serviceName"
      :initial-username="initialUsername"
      :initial-fullname="initialFullname"
      :initial-from="initialFrom"
      :initial-to="initialTo"
      :initial-min-status-code="initialMinStatusCode"
      :initial-max-status-code="initialMaxStatusCode"
      :initial-top="initialTop"
      @close="closeAndResetLogsActionsDrawer"
    />
  </template>

  <!-- Mobile Web: BottomBar + Drawer -->
  <template v-else-if="layoutContext === LAYOUT_CONTEXT.MOBILE_WEB">
    <TopBarMobileWeb />
    <BottomBarMobileWeb />
    <DrawerMobileWeb :is-open="uiStore.isDrawerOpen" @close="uiStore.closeDrawer" />
  </template>

  <!-- Native Mobile (Capacitor): TabBar native -->
  <template v-else-if="layoutContext === LAYOUT_CONTEXT.NATIVE_MOBILE">
    <TabBarV2Mobile />
    <ModalMobileLayout :is-open="uiStore.isDrawerOpen" @close="uiStore.closeDrawer" />
  </template>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useDeviceDetection } from '@/common/composables/useDeviceDetection';
import { useUIStore } from '@/common/stores/uiStore';
import { LAYOUT_CONTEXT } from '@/layouts/constants';
import { logger } from '@/common/services/config';

// Desktop Web components
import TopBarDesktop from '@/layouts/navigation-layout/desktop/TopBarDesktop.vue';
import SideMenuDesktop from '@/layouts/navigation-layout/desktop/SideMenuDesktop.vue';

// Mobile Web components
import BottomBarMobileWeb from '@/layouts/navigation-layout/web-mobile/BottomBarMobileWeb.vue';
import DrawerMobileWeb from '@/layouts/navigation-layout/web-mobile/DrawerMobileWeb.vue';
import TopBarMobileWeb from '@/layouts/navigation-layout/web-mobile/TopBarMobileWeb.vue';

// Native Mobile components
import TabBarV2Mobile from '@/layouts/navigation-layout/native-mobile/TabBarV2Mobile.vue';
import ModalMobileLayout from '@/layouts/navigation-layout/native-mobile/ModalMenuMobile.vue';
import { useMenuLinkStore } from '@/features/menu-management/stores/menuLinkStore';
import { useModuleApi } from '@/features/menu-management/composables';
import { LogsActionsDrawer, useLogsActionsDrawer } from '@/features/logs-actions';

const uiStore = useUIStore();
const { layoutContext } = useDeviceDetection();
const { fetchModules } = useModuleApi();
const linkStore = useMenuLinkStore();
const {
  isOpen,
  serviceName,
  initialUsername,
  initialFullname,
  initialFrom,
  initialTo,
  initialMinStatusCode,
  initialMaxStatusCode,
  initialTop,
  closeAndResetLogsActionsDrawer,
} = useLogsActionsDrawer();

// Close drawer by default in mobile-web context
onMounted(async () => {
  if (layoutContext.value === LAYOUT_CONTEXT.MOBILE_WEB) {
    uiStore.closeDrawer();
  }
  try {
    await fetchModules();
    await linkStore.fetchLinks();
  } catch (error) {
    logger.error('[CategoriesList] Failed to load data:', error);
  }
});
</script>
